export {Tooltip} from 'antd';
export type {
    TooltipAlignConfig,
    AbstractTooltipProps,
    AdjustOverflow,
    PlacementsConfig,
    RenderFunction,
    TooltipPlacement,
    TooltipProps,
    TooltipPropsWithOverlay,
    TooltipPropsWithTitle
} from 'antd/es/tooltip/index';
